import { Icon } from "@iconify/react/dist/iconify.js";
import { Link, useParams } from "react-router-dom";
import PlantelConfirmationTabs from "../../components/plantels/confirmation-plantel/PlantelConfirmationTabs";

const PlantelConfirmationPage = () => {
  const { plantelId } = useParams();
  console.log(plantelId);

  return (
    <div className="container-fluid">
      {/* HEADER */}
      <div className="mb-3">
        <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-2">
          {/* izquierda */}
          <div className="d-flex align-items-center gap-2 flex-wrap">
            <h6 className="mb-0 fw-semibold">
              Confirmación de talentos del plantel
            </h6>
          </div>

          <Link
            className="btn btn-outline-primary d-flex align-items-center gap-2 btn-sm"
            to="/planteles"
          >
            <Icon icon="mdi:arrow-left" width="18" />
            <span>Atras</span>
          </Link>
        </div>
      </div>

      {/* CARD */}
      <div className="card radius-8">
        <PlantelConfirmationTabs />
      </div>
    </div>
  );
};

export default PlantelConfirmationPage;
